import * as React from 'react';

import {FormattedTimestamp} from '../../timestamp/formatted-timestamp';
import {Body} from '../../typography/body';

type Props = {
    description: string | null | undefined;
    role?: string | null | undefined;
    phoneNumber: string | null | undefined;
    phoneExtension?: string | null | undefined;
    email: string | null | undefined;
    phoneContent?: React.ReactNode;
    emailContent?: React.ReactNode;
    lastContactedTime?: string | null | undefined;
};

export function ContactCardContents(props: Props) {
    const lastContactedTimeText = props.lastContactedTime ? (
        <div className='flex'>
            Contacted&nbsp;
            <FormattedTimestamp
                datetime={Number(props.lastContactedTime)}
                format={FormattedTimestamp.formats.monthDayYear}
            />
        </div>
    ) : (
        'Never contacted'
    );

    const renderPhone = () => {
        if (props.phoneContent) {
            return <div className='flex align-center gap-4'>{props.phoneContent}</div>;
        }

        if (!props.phoneNumber) {
            return null;
        }

        return (
            <Body size='small' as='div'>
                {props.phoneNumber} {props.phoneExtension && `ext. ${props.phoneExtension}`}
            </Body>
        );
    };

    const renderEmail = () => {
        if (props.emailContent) {
            return <div className='flex align-center gap-4'>{props.emailContent}</div>;
        }

        if (!props.email) {
            return null;
        }

        return (
            <Body size='small' as='div'>
                {props.email}
            </Body>
        );
    };

    return (
        <div className='flex flex-dir-col gap-2 word-break'>
            {props.description && (
                <Body size='small' as='div'>
                    {props.description}
                </Body>
            )}
            {props.role && (
                <Body size='small' as='div'>
                    {props.role}
                </Body>
            )}
            {renderPhone()}
            {renderEmail()}
            {props.lastContactedTime && (
                <Body size='small' color='placeholder'>
                    {lastContactedTimeText}
                </Body>
            )}
        </div>
    );
}
